export default __webpack_public_path__ + "static/media/advantageImg.94a9b49e.png";